module.exports = __webpack_public_path__ + "static/media/gabs-512.1162d0d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gabs-512.png
// module id = 769
// module chunks = 0